import type { RowModelType } from "ag-grid-enterprise";
import type { GridOptions } from "~/components/grid/AgGrid";

export const isServerSideRowModel = (rowModelType?: RowModelType, gridOptions?: GridOptions): boolean =>
	(rowModelType ?? gridOptions?.rowModelType) === "serverSide";
